import React from "react";
import ScrollToTop from "../ScrollToTop/ScrollToTop";

export default function PageContent({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
    <ScrollToTop/>
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <div
        style={{ padding: "0 20px 50px 0", maxWidth: "1000px", width: "100%" }}
      >
        {children}
      </div>
    </div>
    </>
  );
}
